import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, localize, setInteractionMode } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import nl from 'vee-validate/dist/locale/nl.json'
import de from 'vee-validate/dist/locale/de.json'
import es from 'vee-validate/dist/locale/es.json'
import fr from 'vee-validate/dist/locale/fr.json'
import * as rules from 'vee-validate/dist/rules'
import customEn from '../locales/en/validations'
import customNl from '../locales/nl/validations'
import customDe from '../locales/de/validations'
import customEs from '../locales/es/validations'
import customFr from '../locales/fr/validations'
import { multipleEmailMessage, multipleEmailRule } from '@/plugins/vee-validate-custom-rules/multipleEmail'
import { uniqueMessage, uniqueRule } from '@/plugins/vee-validate-custom-rules/unique'

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

multipleEmailRule(extend)
uniqueRule(extend)

// Install English and Dutch localizations.
localize({
  en: {
    messages: { ...en.messages, ...multipleEmailMessage.en, ...uniqueMessage.en },
    names: customEn.names
  },
  nl: {
    messages: { ...nl.messages, ...multipleEmailMessage.nl, ...uniqueMessage.nl },
    names: customNl.names
  },
  de: {
    messages: { ...de.messages, ...multipleEmailMessage.de, ...uniqueMessage.de },
    names: customDe.names
  },
  es: {
    messages: { ...es.messages, ...multipleEmailMessage.es, ...uniqueMessage.es },
    names: customEs.names
  },
  fr: {
    messages: { ...fr.messages, ...multipleEmailMessage.fr, ...uniqueMessage.fr },
    names: customFr.names
  }
})

localize('nl')

setInteractionMode('fuseboxEager', (context) => {
  return { on: ['input'], debounce: 400 }
})

// Install components globally
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
